import {View} from 'native-base';
import React from 'react';

import {OfferFiltersDestination} from 'models/OfferFilters';

import OfferFilterList from '../List';

export interface OfferDestinationListProps {
  destinations: OfferFiltersDestination[];
  selected: OfferFiltersDestination | undefined;
  onSelect: (item: OfferFiltersDestination) => void;
  availableProperties?: string[];
  offersCount: {[key: string]: number};
}

const OfferDestinationList: React.FC<OfferDestinationListProps> = props => {
  const {destinations, selected, onSelect, availableProperties, offersCount} =
    props;
  const handleSelect = item => () => {
    onSelect && onSelect(item as OfferFiltersDestination);
  };

  const isSelected = item => selected?.id === item.id;

  return (
    <View flex={1}>
      <OfferFilterList
        list={destinations}
        onSelect={handleSelect}
        isSelected={isSelected}
        offersCount={offersCount}
        setBottomBorder={true}
        isModal={true}
        availableProperties={availableProperties}
      />
    </View>
  );
};

export default OfferDestinationList;
